__turbopack_context__.v({
  "collapsibleItem": "CollapsibleItemBlock-module__bz7yXW__collapsibleItem",
});
